// styles
import classNames from "classnames";

import styles from "./styles.module.scss";

interface Props {
  header: string;
  subHeader: string;
  boldText?: string;
}

export const FormHeading = ({ header, subHeader, boldText }: Props) => {
  return (
    <div className={styles["container"]}>
      <h1>{header}</h1>
      <div className={styles.subtitleContainer}>
        <p className={classNames("subtitle1", "g700")}>{subHeader}</p>
        <p className={"subtitle1"}>{boldText}</p>
      </div>
    </div>
  );
};

export default FormHeading;
